var map = {
	"./alpgw_web.webp": 1638,
	"./moonshot.webp": 3611,
	"./nuhs_balloon.webp": 8706,
	"./nuhs_dalgona.webp": 9394,
	"./nuhs_wordle.webp": 391,
	"./queenswayAF.webp": 7488,
	"./webbricks_web.webp": 7052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8054;